import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Table, SectionTitle } from "../../../shared";
import Action from "./action";
import { ALL_PERSONA_AUDIENCE } from "./query";
import { AxiosGraphQlAction, Helper } from "../../../services";
import { setPersonaList, getPersonaList } from "../../reducers";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const columns = [
    {
        accessorKey: "personaName",
        header: "Persona Name",
    },
    {
        accessorKey: "appName",
        header: "Application",
        cell: (cell: any) => Helper.GetAppName(cell.getValue()),
    },
    {
        accessorKey: "country",
        header: "Country",
        cell: (cell: any) => Helper.GetCountryName(cell.getValue()),
    },
];

const renderSubComponent = (data: any) => {
    data.row.original.email = data.row.original.email || [];
    data.row.original.audienceSpecialty = data.row.original.audienceSpecialty || [];
    return <Action data={data.row.original} />;
};

const PersonaAudience = (props: any) => {
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState(
        props.countryList.length
            ? {
                  personaType: {
                      equalTo: "Audience",
                  },
                  country: {
                      in: [...props.countryList],
                  },
              }
            : {
                  personaType: {
                      equalTo: "Audience",
                  },
              }
    );
    const [{ pageIndex, pageSize }, setPagination] = React.useState({
        pageIndex: 0,
        pageSize: 10,
    });

    const pagination = React.useMemo(
        () => ({
            pageIndex,
            pageSize,
        }),
        [pageIndex, pageSize]
    );

    const [tableInfo, setTableInfo] = useState({
        pageIndex,
        pageSize,
        totalCount: 0,
        pageInfo: {
            hasNextPage: undefined,
            hasPreviousPage: undefined,
            startCursor: undefined,
            endCursor: undefined,
        },
    });

    useEffect((): any => {
        setLoading(true);
        let isApiCalled = true;
        if (isApiCalled) {
            const { startCursor, endCursor } = tableInfo.pageInfo;
            let variables = {};

            if (pageIndex > tableInfo.pageIndex) {
                variables = {
                    filter: {
                        ...filter,
                    },
                    last: undefined,
                    before: undefined,
                    first: endCursor ? pageSize : undefined,
                    after: endCursor,
                };
            } else if (pageIndex < tableInfo.pageIndex) {
                variables = {
                    filter: {
                        ...filter,
                    },
                    last: startCursor ? pageSize : undefined,
                    before: startCursor,
                    first: startCursor ? undefined : pageSize,
                    after: undefined,
                };
            } else {
                variables = {
                    filter: {
                        ...filter,
                    },
                    first: pageSize,
                    after: undefined,
                    last: undefined,
                    before: undefined,
                };
            }

            AxiosGraphQlAction(variables, ALL_PERSONA_AUDIENCE)
                .then(({ data }) => {
                    const personaAudienceList = data.data.allAbbvieProPersonas.nodes;
                    const pageInfo = data.data.allAbbvieProPersonas.pageInfo;
                    const totalCount = data.data.allAbbvieProPersonas.totalCount;

                    setTableInfo({
                        pageIndex,
                        pageSize,
                        totalCount,
                        pageInfo: { ...pageInfo },
                    });
                    setLoading(false);
                    props.setPersonaList(personaAudienceList);
                })
                .catch((err) => {
                    toast.error(err.message);
                });
        }
        return () => {
            props.setPersonaList([]);
            isApiCalled = false;
        };
    }, [pageIndex, pageSize, filter]);

    const handleChange = (value: string, columnName: string) => {
        const filterType =
            columnName === "appName"
                ? "equalTo"
                : columnName === "country"
                  ? "in"
                  : "includesInsensitive";

        const defaultValue = columnName === "country" ? [...props.countryList] : "";

        if (value) {
            setFilter({
                ...filter,
                [columnName]: {
                    [filterType]: value,
                },
            });
        } else {
            if (columnName === "appName" || columnName === "personaName") {
                // @ts-expect-error: Unreachable code error
                const { [columnName]: valueToRemove, ...newFilter } = filter;
                setFilter(newFilter);
            } else if (columnName === "country" && props.countryList.length === 0) {
                delete filter?.country;
                setFilter({
                    ...filter,
                });
            } else {
                setFilter({
                    ...filter,
                    [columnName]: {
                        [filterType]: defaultValue,
                    },
                });
            }
        }
    };

    const pageCount = Math.ceil(tableInfo.totalCount / pageSize);

    const pageSizeChangeAction = () => {
        setTableInfo({
            ...tableInfo,
            pageInfo: {
                hasNextPage: undefined,
                hasPreviousPage: undefined,
                startCursor: undefined,
                endCursor: undefined,
            },
        });
    };
    return (
        <>
            <Link to="/abbvie-pro/persona" className="btn btn-outline-primary mb-5">
                Back
            </Link>
            <SectionTitle
                title="Persona Audience"
                buttonText="Create"
                buttonUrl="/abbvie-pro/persona/audience/create"
            />

            <Table
                data={props.personaAudience}
                headers={columns}
                getRowCanExpand={() => true}
                renderSubComponent={renderSubComponent}
                loading={loading}
                pageCount={pageCount}
                totalCount={tableInfo.totalCount}
                pagination={pagination}
                onPaginationChange={setPagination}
                handleFilter={(value: string, columnName: string) => {
                    handleChange(value, columnName);
                }}
                pageSizeChangeAction={() => {
                    pageSizeChangeAction();
                }}
            />
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        personaAudience: getPersonaList(state),
        countryList: state.users.currentUser.userType === 1 ? state.users.currentUser.country : [],
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setPersonaList: (personaList: any) => {
            dispatch(setPersonaList(personaList));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonaAudience);
